<template>
  <div class="instructions-domain">
    <div class="container">
      <VBtn
        dark
        color="success"
        elevation="0"
        @click="$router.go(-1)"
      >
        {{ $t('back') }}
      </VBtn>
      <div class="instructions-domain__title">
        {{ $t('titleInstructionDomain') }}
      </div>

      <div class="instructions-domain__subtitle">
        {{ $t('subtitleInstructionDomain') }}
      </div>

      <div class="mb-4">
        {{ $t('stepFirst') }} <br> {{ $t('stepFirstText') }}
      </div>

      <div class="mb-4">
        {{ $t('stepTwice') }} <br> {{ $t('stepTwiceText') }}
      </div>

      <div class="mb-4">
        {{ $t('stepThird') }} <br> {{ $t('stepThirdSubTitle') }} <br> {{ $t('stepThirdText1') }}
        <br> {{ $t('stepThirdText2') + ` ${aRecordIp} .` }}
      </div>

      <div class="mb-4">
        {{ $t('stepFourth') }} <br> {{ $t('stepFourthTextBefore') }}<b>{{ $t('stepFourthText') }}</b> {{ $t('stepFourthTextAfter') }}
      </div>

      <div>{{ $t('stepFifth') }} <br>{{ $t('stepFifthText') }}</div>

      <VBtn
        dark
        color="success"
        class="mt-4"
        elevation="0"
        @click="$router.go(-1)"
      >
        {{ $t('done') }}
      </VBtn>
      <div class="mt-5">
        {{ $t('help') }} <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { SUPPORT_EMAIL } from '@/helpers/constants';

const aRecordIp = process.env.VUE_APP_A_RECORD_IP;
export default {
  name: 'DomainInstructions',
  setup() {
    return {
      aRecordIp,
      supportEmail: SUPPORT_EMAIL,
    };
  },
};
</script>

<style lang="scss" scoped>
.instructions-domain {
  &__title {
    font-weight: 400;
    font-size: 23px;
    line-height: 20px;
    color: #212121;
    margin: 30px 0;
  }
  &__subtitle {
    font-size: 17px;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>

<i18n locale="en" lang="yaml">
  back: Back
  titleInstructionDomain: Instructions for connecting the domain
  subtitleInstructionDomain: "We would like to guide you through the process of connecting your domain to our platform by creating an
  A record in your domain's DNS settings. Here's a step-by-step guide:"

  stepFirst: 'Step 1: Access your domain registrar'
  stepFirstText: Log in to your domain registrar account (e.g., GoDaddy, Namecheap, Google Domains, etc.), where you initially purchased and manage your domain.

  stepTwice: 'Step 2: Locate the DNS settings'
  stepTwiceText: Once logged in, find the DNS settings for your domain. This is typically located under
        "Domain Management," "DNS Management," "Advanced DNS," or a similar section. Each registrar
        has a slightly different interface, so consult your registrar's help documentation if you
        have difficulty locating the DNS settings.

  stepThird: 'Step 3: Create a new A record'
  stepThirdSubTitle: 'In the DNS settings, look for an option to add a new record. Select "A" as the record type.
        The A record requires two pieces of information:'
  stepThirdText1: "1. Host/Name: This is usually set to '@' or left blank, representing the root domain (e.g., 'example.com').
  If you intend to use a subdomain, input the subdomain here (e.g., 'www' for 'www.example.com')."
  stepThirdText2: '2. Points to/Value: Enter the IP address of the Huntica server we provided'

  stepFourth: 'Step 4: Save the changes'
  stepFourthTextBefore: Save the new A record and any other changes you made to your DNS settings. It may take anywhere from
  stepFourthText: ' a few minutes to 48 hours'
  stepFourthTextAfter: for the changes to propagate across the internet.

  stepFifth: 'Step 5: Verify the connection'
  stepFifthText: "Once the DNS changes have propagated, visit your domain in a
        web browser to confirm that it is connected to the Huntica service. If the connection is not
        successful, double-check your DNS settings and reach out to our support team for further
        assistance. By following these instructions, you will successfully connect your domain to
        the Huntica service using an A record. If you encounter any issues or need additional
        support, don't hesitate to contact our support team or consult your domain registrar's help
        documentation."
  done: "I'm done"
  help: If you have any problems setting up a domain, please contact us.
</i18n>

<i18n locale="ru" lang="yaml">
  back: Назад
  titleInstructionDomain: Инструкция по подключению домена
  subtitleInstructionDomain: 'Мы хотели бы помочь вам подключить ваш домен к нашей платформе, создав запись A в настройках DNS вашего домена.Вот пошаговое руководство:'

  stepFirst: 'Шаг 1: Получите доступ к регистратору домена'
  stepFirstText: Войдите в свою учетную запись регистратора домена (например, GoDaddy, Namecheap, Google Domains и т.д.), где вы изначально приобрели свой домен и управляете им.

  stepTwice: 'Шаг 2. Найдите настройки DNS'
  stepTwiceText: После входа найдите настройки DNS для своего домена. Обычно это расположено под
         «Управление доменом», «Управление DNS», «Расширенный DNS» или аналогичный раздел. Каждый регистратор
         имеет немного другой интерфейс, поэтому обратитесь к справочной документации вашего регистратора, если вы
         возникают трудности с поиском настроек DNS.

  stepThird: 'Шаг 3. Создайте новую запись A.'
  stepThirdSubTitle: 'В настройках DNS найдите опцию добавления новой записи. Выберите «А» в качестве типа записи.
          Запись A требует двух частей информации:'
  stepThirdText1: '1. Хост/имя: обычно указывается «@» или остается пустым, что соответствует корневому домену (например,
         «example.com»). Если вы хотите использовать субдомен, введите здесь субдомен (например, «www» для
         «www.example.com»).'
  stepThirdText2: '2. Указывает на/значение: введите предоставленный нами IP-адрес сервера Huntica.'

  stepFourth: 'Шаг 4: Сохраните изменения'
  stepFourthTextBefore: Сохраните новую запись A и любые другие изменения, внесенные вами в настройки DNS. Это может занять
  stepFourthText: ' от нескольких минут до 48 часов'
  stepFourthTextAfter: для распространения изменений в Интернете.

  stepFifth: 'Шаг 5. Проверьте подключение'
  stepFifthText: "После распространения изменений DNS посетите свой домен в
         веб-браузере, чтобы убедиться, что он подключен к сервису Huntica. Если соединение не
         успешно, дважды проверьте настройки DNS и обратитесь в нашу службу поддержки для получения дополнительной информации.
         Следуя этим инструкциям, вы успешно подключите свой домен к
         сервис Huntica с использованием записи A. Если вы столкнулись с какими-либо проблемами или нуждаетесь в дополнительных
         поддержку, не стесняйтесь обращаться в нашу службу поддержки или обратитесь за помощью к своему регистратору доменов."
  done: Я все сделал!
  help: Если у вас возникли проблемы с настройкой домена, пишите нам
</i18n>
